import "./footer.scss";

interface FooterProps {}

const Footer: React.FunctionComponent<FooterProps> = () => {
  const isMobile = window.innerWidth <= 768;

  return (
    <footer>
      <p className="main">
        <span className="spec">Rankaque</span> allows your audience to{" "}
        <span className="spec">express</span> {!isMobile && <br />}
        <span className="spec">questions anonymously</span> in any of your
        lectures
      </p>
      <button>Get Started</button>
      <div className="lastLine">
        <p>Copyright (c) Rankaque 2022</p>
        <div className="rgt">
          <p>Terms of Use</p>
          <p>Privacy Policy</p>
          <p>FAQs</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
